// Unpublished Work © 2021-2025 Deere & Company.

import t from 'tcomb';

export const Phone = t.struct({
    areaCode: t.String,
    canMarket: t.Boolean,
    communicationLocatorId: t.Number,
    countryCode: t.String,
    extension: t.String,
    formattedPhone: t.String,
    phoneNumber: t.String,
    smsOptOut: t.Boolean,
    mobilePhoneCheck: t.Boolean
}, {
    defaultProps: {
        areaCode: '',
        canMarket: true,
        communicationLocatorId: 0,
        countryCode: '',
        extension: '',
        formattedPhone: '',
        phoneNumber: '',
        smsOptOut: true,
        mobilePhoneCheck: true
    },
    name: 'Phone',
    strict: true
});

Phone.prototype.isDefault = function (countryCode) {
    const defaultContactPhone = new Phone({});

    return [
        this.areaCode === defaultContactPhone.areaCode,
        this.countryCode === countryCode,
        this.extension === defaultContactPhone.extension,
        this.phoneNumber === defaultContactPhone.phoneNumber
    ].every((condition) => condition);
};
